<template>
	<div class="btn btn-buy" @click="buyProduct">
		Comprar
	</div>
</template>

<script>
import ecommerceMixins from './mixins'

export default {
	name: 'BuyButton',
	mixims: [ecommerceMixins],
	props: {
		product: {
			required: true,
		},
	},
	data() {
		return {
			qty: 1,
		}
	},
	methods: {
		buyProduct() {
			this.$nextTick(() => {
				this.addToCart(this.product, this.qty)
			})
		},
	},
}
</script>
<style scoped></style>
